const AUTH_TOKEN_KEY = "authToken";
const OLD_TOKEN_KEY = "token";
const USER_KEY = "user";
const NAME_KEY = "name";
const ROLE_KEY = "role";
const REFRESH_TOKEN_KEY = "refreshToken";

export const setAuthSession = ({ token, refreshToken, name, role, user }) => {
  if (token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
    localStorage.setItem(OLD_TOKEN_KEY, token);
  }
  if (refreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);

  if (name) localStorage.setItem(NAME_KEY, name);
  if (role) localStorage.setItem(ROLE_KEY, role);
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const getRefreshToken = () =>
  localStorage.getItem(REFRESH_TOKEN_KEY) || "";

export const getAuthToken = () => {
  return (
    localStorage.getItem(AUTH_TOKEN_KEY) ||
    localStorage.getItem(OLD_TOKEN_KEY) ||
    ""
  );
};

export const getUser = () => {
  const user = localStorage.getItem(USER_KEY);

  if (!user) return null;

  try {
    return JSON.parse(user);
  } catch {
    return null;
  }
};

export const getUserName = () => {
  const user = getUser();

  return (
    user?.name ||
    localStorage.getItem(NAME_KEY) ||
    localStorage.getItem("bmsdDoctor") ||
    ""
  );
};

export const getUserRole = () => {
  const user = getUser();

  return user?.role || localStorage.getItem(ROLE_KEY) || "";
};

export const getDoctorName = getUserName;

export const clearAuthSession = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(OLD_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(NAME_KEY);
  localStorage.removeItem(ROLE_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem("bmsdDoctor");
  localStorage.removeItem("userName");
};
